import { Pipe, PipeTransform } from '@angular/core';
// import { first } from 'rxjs/operators';

@Pipe({ name: 'keyValue' })
export class KeysValue implements PipeTransform {
      transform(value, args): any {
      let keyValue: any;
      for (const key in value) {
        if (value.hasOwnProperty(key)) {
         keyValue = {key: key, value: value[key]};
        }
      }
      if (args === 'key') {
       return keyValue.key;
      } else {
       return keyValue.value;
      }
      }
}
